module.exports = __webpack_public_path__ + "img/marketingPauta.668986ca.png";